import {
  useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  CheckCircleOutlined,
  AppstoreOutlined,
  ApiOutlined,
  BarChartOutlined,
  FundOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <AppstoreOutlined />,
  1: <ApiOutlined />,
  2: <BarChartOutlined />,
  3: <FundOutlined />,
};

const HighlightsSection = () => {
  const { t } = useTranslation("erpMini");

  const items = useMemo(() => {
    const raw = t("highlights.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  const statValue = t("highlights.stat_value");
  const statLabel = t("highlights.stat_label");
  const statDesc = t("highlights.stat_desc");
  const statSecondaryValue = t("highlights.stat_secondary_value");
  const statSecondaryLabel = t("highlights.stat_secondary_label");

  return (
    <section className="dev-erpMini-section dev-erpMini-highlights-section">
      <div className="dev-erpMini-section-inner">
        <h2 className="dev-section-h2 dev-erpMini-section-h2">
          <span className="dev-erpMini-section-h2-icon dev-erpMini-section-h2-icon--cyan" aria-hidden>
            <AppstoreOutlined />
          </span>
          <span>{t("highlights.title")}</span>
        </h2>

        <div className="dev-erpMini-highlights-grid">
          <div className="dev-erpMini-highlight-list">
            {items.map((item, idx) => (
              <div key={idx} className="dev-erpMini-highlight-item">
                <div className="dev-erpMini-highlight-icon">
                  {iconByIndex[idx] ?? <CheckCircleOutlined />}
                </div>
                <div>
                  <div className="dev-erpMini-highlight-title">{item.title}</div>
                  <div className="dev-erpMini-highlight-desc">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="dev-erpMini-stat-card dev-erpMini-stat-card--dual">
            <div className="dev-erpMini-stat-dual-grid">
              <div className="dev-erpMini-stat-dual-item">
                <div className="dev-erpMini-stat-value">{statValue}</div>
                <div className="dev-erpMini-stat-label">{statLabel}</div>
              </div>
              <div className="dev-erpMini-stat-dual-divider" aria-hidden />
              <div className="dev-erpMini-stat-dual-item">
                <div className="dev-erpMini-stat-value dev-erpMini-stat-value--secondary">{statSecondaryValue}</div>
                <div className="dev-erpMini-stat-label">{statSecondaryLabel}</div>
              </div>
            </div>
            <div className="dev-erpMini-stat-desc">{statDesc}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;
